<template>
  <div class="full-layout-error__content">
    <div style="width: 100%;position: absolute;right: 20px;top: 10px;">
    <b-link
      @click="logout"
      style="float:right;"
    >
      {{ $tk('ClientPortal.UserMenu.Logout') }}
    </b-link>
    </div>

    <img
      :key="'img-' + errorStatusCode"
      :src="getErrorImage()"
      class="img-fuild"
    >
    <h4
      :key="'title-' + errorStatusCode"
      class="full-layout-error__title"
    >
      {{ $tk(getErrorTitle()) }}
    </h4>
    <p
      :key="'label-' + errorStatusCode"
      class="full-layout-error__label"
    >
      {{ $tk(`${getErrorTitle()}Info`) }}
    </p>
    <div class="full-layout-error__actions">
      <b-button
        variant="outline-primary"
        class="full-layout-error__button"
        @click="refreshPage"
      >
        {{ $tk('ClientPortal.User.RefreshPage') }}
      </b-button>
      <b-button
        variant="primary"
        class="full-layout-error__button"
        :to="accountId !== undefined ? `/` : '/'"
      >
        {{ $tk('ClientPortal.User.ReturnToTheHome') }}
      </b-button>
    </div>

  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'
import { logoutUser } from '../../../../GjirafaFront/script/auth'

export default {
  setup() {
    const { accountId } = store.getters['verticalMenu/accountContext']
    const errorStatusCode = router.currentRoute.hash

    const getErrorImage = () => {
      switch (errorStatusCode) {
        case '#400':
          // eslint-disable-next-line global-require
          return require('@/assets/illustrations/error-400.svg')
        case '#401':
          // eslint-disable-next-line global-require
          return require('@/assets/illustrations/error-401.svg')
        case '#403':
          // eslint-disable-next-line global-require
          return require('@/assets/illustrations/error-403.svg')
        case '#404':
          // eslint-disable-next-line global-require
          return require('@/assets/illustrations/error-404.svg')
        case '#500':
          // eslint-disable-next-line global-require
          return require('@/assets/illustrations/error-500.svg')
        case '#503':
          // eslint-disable-next-line global-require
          return require('@/assets/illustrations/error-503.svg')
        default:
          // eslint-disable-next-line global-require
          return require('@/assets/illustrations/error-404.svg')
      }
    }

    const getErrorTitle = () => {
      switch (errorStatusCode) {
        case '#400':
          return 'ClientPortal.User.BadRequest'
        case '#401':
          return 'ClientPortal.User.UnauthorizedAccess'
        case '#403':
          return 'ClientPortal.User.Forbidden'
        case '#404':
          return 'ClientPortal.User.PageNotFound'
        case '#500':
          return 'ClientPortal.User.InternalServerError'
        case '#503':
          return 'ClientPortal.User.ServiceUnavailable'
        default:
          return 'ClientPortal.User.PageNotFound'
      }
    }

    const refreshPage = () => { if (window.history.length > 2) { router.go(-1) } else { router.push('/') } }

    return {
      accountId, refreshPage, getErrorImage, getErrorTitle, errorStatusCode,
    }
  },
  methods: {
    logout() {
      localStorage.clear()
      logoutUser('auth-login')
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/components/error.scss';
</style>
